import { useApi } from '@omnipresentgroup/api';
import type { CreateContractorRequestAPI } from '@omnipresentgroup/types';
import {
  type UseMutationOptions,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';

import { INTEGRATION_API_BASE } from '../constants';
import { getMergeIntegrationKey } from './useMergeIntegration';

export const CREATE_MERGE_INTEGRATION_LINK_PATH = 'merge/generate-magic-link';

export const useMergeLinkCreationMutation = ({
  onSuccess,
  ...options
}: Omit<UseMutationOptions, 'mutationFn'>) => {
  const { POST } = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () =>
      POST<CreateContractorRequestAPI>({
        path: `${INTEGRATION_API_BASE}/${CREATE_MERGE_INTEGRATION_LINK_PATH}`,
      }),
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries({ queryKey: getMergeIntegrationKey() });
      onSuccess?.(data, variables, context);
    },
    ...options,
  });
};
